import { render } from "./OurProductsComp.vue?vue&type=template&id=969db7cc&scoped=true"
import script from "./OurProductsComp.vue?vue&type=script&lang=js"
export * from "./OurProductsComp.vue?vue&type=script&lang=js"

import "./OurProductsComp.vue?vue&type=style&index=0&id=969db7cc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969db7cc"]])

export default __exports__